function isColourDark(colour = '#000000') {
  const hexCode = colour.substring(1);
  const rgb = parseInt(hexCode, 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;
  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

  return luma < 40;
}

function ColourSwatchMultiColour({ id }: { id: string }) {
  return (
    <linearGradient
      id={id}
      x1="8.03"
      y1="41.97"
      x2="41.97"
      y2="8.03"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#7ff9c4" />
      <stop offset="0.08" stopColor="#93f8b2" />
      <stop offset="0.49" stopColor="#f8f156" />
      <stop offset="0.6" stopColor="#fad56a" />
      <stop offset="0.87" stopColor="#fd949a" />
      <stop offset="1" stopColor="#ff7bac" />
    </linearGradient>
  );
}

type Props = {
  fill: string;
  isRefined: boolean;
  width?: number;
};

export default function ColourCheckbox({
  width = 20,
  fill = '#000000',
  isRefined = false
}: Props) {
  const multiColour = fill === '0';
  const tickFillActive = isColourDark(fill) ? '#FFFFFF' : '#000000';
  const tickFill = isRefined ? tickFillActive : 'transparent';
  const randomTag = (Math.floor(Math.random() * 1000) + 1).toString();

  return (
    <svg width={width} viewBox="0 0 50 50">
      {multiColour && <ColourSwatchMultiColour id={randomTag} />}
      <circle
        stroke={`${fill === '#FFFFFF' && '#000000'}`}
        cx="25"
        cy="25"
        r="24"
        fill={multiColour ? `url(#${randomTag})` : fill}
      />
      <path
        fill={tickFill}
        d="M20.94,41a3,3,0,0,1-2.07-.82L8.94,30.75a3,3,0,1,1,4.12-4.35l7.5,7.11,16-21.31a3,3,0,0,1,4.8,3.6l-18.07,24A3,3,0,0,1,21.18,41Z"
      />
    </svg>
  );
}
